import React from 'react'
import Hero from 'parts/Home/Hero'
import OurSolution from 'parts/Home/OurSolution'
import Industries from 'parts/Home/Industries'
import Maps from 'parts/Home/Maps'
import Customer from 'parts/Home/Customer'
import CustomerService from 'parts/Home/CustomerService'
import Testimoni from 'parts/Home/Testimoni'
import NewsLetter from 'parts/Home/NewsLetter'
import Mission from 'parts/Home/Mission'
import { useOutletContext } from 'react-router'

const Home = () => {
  const { refTabOurSolution } = useOutletContext()

  return (
    <>
      <Hero/>
      <Mission/>
      <OurSolution refTab={refTabOurSolution} />
      <Industries/>
      <Maps/>
      <Customer/>
      <CustomerService/>
      <Testimoni/>
      <NewsLetter/>
    </>
  )
}

export default Home
